app.filter("dotDate", function() {
    return function(input){
        var date = moment(input,"YYYY-MM-DD").format('YYYY.MM.DD');
        return date;
    }
});
